import { render, staticRenderFns } from "./titleTextAttr.vue?vue&type=template&id=c562431e&scoped=true"
import script from "./titleTextAttr.vue?vue&type=script&lang=js"
export * from "./titleTextAttr.vue?vue&type=script&lang=js"
import style0 from "./titleTextAttr.vue?vue&type=style&index=0&id=c562431e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c562431e",
  null
  
)

component.options.__file = "titleTextAttr.vue"
export default component.exports